<template>
    <div v-if="themeStore.themeIndex === 1">
        <WithdrawViewOne ref="withdrawRef" :data-set="dataSet" @input-value-change="inputValueChange"
            @select-channel="selectChannel" @confirm-withdraw="confirmWithdraw" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <WithdrawViewTwo ref="withdrawRef" :data-set="dataSet" @input-value-change="inputValueChange"
            @select-channel="selectChannel" @confirm-withdraw="confirmWithdraw" @showError="showError"
            @showSuccess="showSuccess" @showLoading="showLoading" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <WithdrawViewThree ref="withdrawRef" :data-set="dataSet" @input-value-change="inputValueChange"
            @select-channel="selectChannel" @confirm-withdraw="confirmWithdraw" @showError="showError"
            @showSuccess="showSuccess" @showLoading="showLoading" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" :isLoading="isLoading" />
    <WithdrawPopup ref="withdrawConfirmRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { getChannels, withdrawSettingByUserID } from '@/api/withdraw';
import { PAYMENT_TYPE } from '@/constants';
import { PayChannel } from '@/types/common';
import { useWithdrawStore } from '@/stores/withdraw';
import WithdrawViewOne from '@/themes/themeOne/withdraw/withdrawView.vue';
import WithdrawViewTwo from '@/themes/themeTwo/withdraw/withdrawView.vue';
import WithdrawViewThree from '@/themes/themeThree/withdraw/withdrawView.vue';
import { WithdrawViewData } from './supportScript';
import WithdrawPopup from './withdrawPopup.vue';
import { useThemeStore } from '@/stores/theme';

const userStore = useUserStore()
const themeStore = useThemeStore()
const withdrawStore = useWithdrawStore()
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const isLoading = ref(false)
const withdrawControls = computed(() => userStore.withdrawControls)

const channelList = ref<PayChannel[]>([])
const activeChannel = ref<PayChannel>({
    id: 0,
    name: '',
    channelType: ''
})
const selectedAmount = ref<number | string>('')
const balanceAmount = computed(() => userStore.balance)
const activeButton = ref(false)
const uId = computed(() => userStore.id)
const remainingTurnOver = computed(() => userStore.userAccount.requiredTurnover - userStore.userAccount.turnover)

const dataSet = computed<WithdrawViewData>(() => ({
    channelList: channelList.value,
    activeChannel: activeChannel.value,
    balanceAmount: balanceAmount.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    uId: uId.value,
    remainingTurnOver: remainingTurnOver.value,
    withdrawControls: withdrawControls.value
}))

const withdrawRef = ref()
const withdrawConfirmRef = ref()

const selectChannel = (item: PayChannel) => {
    activeChannel.value = item
    withdrawStore.setSelectedWithdrawChannel(activeChannel.value)
}

const inputValueChange = (val: any) => {

    if (balanceAmount.value < val) {
        selectedAmount.value = balanceAmount.value
    } else {
        selectedAmount.value = val
    }
    if (val > 0) {
        activeButton.value = true
    } else {
        activeButton.value = false
    }
}
const showError = (message: string) => {
    isLoading.value = false
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    isLoading.value = false
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const showLoading = (val: boolean) => {
    isLoading.value = val
    statusRef.value.open()
}
const getChannelList = () => {
    getChannels({ paymentType: PAYMENT_TYPE.WITHDRAW }).then(res => {
        channelList.value = res.data;
        withdrawStore.setWithdrawList(channelList.value)
        activeChannel.value = channelList.value[0] || { id: 0, name: '' };
        withdrawStore.setSelectedWithdrawChannel(activeChannel.value)
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
        }

    });
}
const confirmWithdraw = () => {
    let data = {
        uid: uId.value
    }
    withdrawSettingByUserID(data).then(res => {
        let resData = res.data
        withdrawStore.setWithdrawInfo(resData)
        // withdrawRef.value.openWithdrawConfirm(selectedAmount.value, resData)
        withdrawConfirmRef.value.open(selectedAmount.value, resData)

    }).catch(err => {
        if (err.code != 401) {
            showError(err);
        }
    })

}
onMounted(() => {
    userStore.getInfo()
    getChannelList()
})
</script>
<style scoped>
.withdraw_container {
    padding: 70px 0;
}

.channel_text {
    color: #ffffffd9;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 25px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 25px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px 30px;
    margin-right: 10px;
    font-size: 14px;
}

.active_channel {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    border-radius: 5px;
    padding: 15px 10px;
}

.line {
    margin-top: 5px;
    height: 0.5px;
    width: 100%;
    background: rgba(255, 255, 255, 0.25);
    ;
}

.btn_container {
    padding: 30px 90px;
}

.balance_container {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 3vh;
}

.balance_text {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.65);
}

.balance_value {
    color: rgba(255, 255, 255, 0.85);
    font-size: 45px;
}

.sub_container {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.top-banner {
    padding: 5px 15px;
}

.top-banner img {
    width: 100%;
    border-radius: 20px;
}

@media (min-width: 1440px) {
    .channel_text {
        font-size: 3vh;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }

    .active_channel {
        padding: 15px 3vh !important;
    }
}

@media (min-width: 1920px) {
    .channel_text {
        font-size: 3vh;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 2vh;
    }

    .active_channel {
        padding: 15px 3vh !important;
    }
}
</style>